import { render, staticRenderFns } from "./WithdrawDeposit.vue?vue&type=template&id=1b96c669&scoped=true"
import script from "./WithdrawDeposit.vue?vue&type=script&lang=js"
export * from "./WithdrawDeposit.vue?vue&type=script&lang=js"
import style0 from "./WithdrawDeposit.vue?vue&type=style&index=0&id=1b96c669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96c669",
  null
  
)

export default component.exports